import { render, staticRenderFns } from "./ChartScopeSwitcher.vue?vue&type=template&id=2b67f393"
import script from "./ChartScopeSwitcher.vue?vue&type=script&setup=true&lang=js"
export * from "./ChartScopeSwitcher.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports